"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationTransferPage = void 0;
const EmptyContentWrapper_1 = require("@juvare/common-web-ui/EmptyContentWrapper");
const PageHeader_1 = require("@juvare/common-web-ui/PageHeader");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const useExportConfigurationHandler_1 = require("../hooks/useExportConfigurationHandler");
const useImportConfigurationHandler_1 = require("../hooks/useImportConfigurationHandler");
const ConfigurationTransferPage = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const { handleExportButtonClick, exportDialog } = (0, useExportConfigurationHandler_1.useExportConfigurationHandler)(props);
    const { handleImportButtonClick, importDialog } = (0, useImportConfigurationHandler_1.useImportConfigurationHandler)(props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PageHeader_1.PageHeaderWithImage, { gradient: 'blue-base', title: t('configurationTransfer.configurationTransfer') }),
        react_1.default.createElement(material_1.Box, { p: 4 },
            react_1.default.createElement(EmptyContentWrapper_1.EmptyContentWrapper, { description: t('configurationTransfer.startConfigurationTransfer') },
                react_1.default.createElement(material_1.Button, { variant: 'contained', onClick: handleExportButtonClick }, t('configurationTransfer.exportConfiguration')),
                t('common.or'),
                react_1.default.createElement(material_1.Button, { variant: 'outlined', onClick: handleImportButtonClick }, t('configurationTransfer.importConfiguration')))),
        exportDialog,
        importDialog));
};
exports.ConfigurationTransferPage = ConfigurationTransferPage;
